import * as React from 'react';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { INavStyles } from '@fluentui/react/lib/Nav';

import SidebarOptions from './SidebarOptions';
import { Usuario } from '../../../system/Usuario/Usuario';

interface ISidebarProps {
  isOpen: boolean;
  dismissPanel: () => void;
  user?: Usuario;
  changeTheme: () => void;
}

const Sidebar: React.FC<ISidebarProps> = (props) => {
  return (
    <div className="h-inherit">
      <SidebarOptions changeTheme={props.changeTheme} user={props.user} className="ms-hiddenMdDown" />
      <Panel
        isLightDismiss
        isOpen={props.isOpen}
        onDismiss={props.dismissPanel}
        closeButtonAriaLabel="Cerrar"
        type={PanelType.smallFixedNear}
        className="ms-hiddenLgUp"
        styles={{ content: { paddingLeft: '0.5rem' } }}
      >
        <SidebarOptions
          changeTheme={props.changeTheme}
          user={props.user}
          onLinkClicked={props.dismissPanel}
        />
      </Panel>
    </div>
  );
};

export default Sidebar;
